require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.3@core-js/library/modules/es7.symbol.observable.js
// module id = 337
// module chunks = 2